import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { useToast } from "@/components/ui/use-toast";
import { PropertyInfoForm } from "@/components/proprietarios/PropertyInfoForm";
import { OwnerSelect } from "@/components/agendamentos/OwnerSelect";
import { useQuery } from "@tanstack/react-query";

export default function NovoImovel() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [selectedOwnerId, setSelectedOwnerId] = useState("");
  
  // Form state
  const [propertyTitle, setPropertyTitle] = useState("");
  const [propertyAddress, setPropertyAddress] = useState("");
  const [propertyType, setPropertyType] = useState("sale");
  const [salePrice, setSalePrice] = useState("");
  const [rentPrice, setRentPrice] = useState("");
  const [seasonalPrice, setSeasonalPrice] = useState("");
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [area, setArea] = useState("");
  const [landArea, setLandArea] = useState("");
  const [description, setDescription] = useState("");

  const { data: owners = [] } = useQuery({
    queryKey: ['owners'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('id, name, email');
      
      if (error) throw error;
      return data;
    }
  });

  const handleSubmit = async (data: any) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        toast({
          variant: "destructive",
          title: "Erro",
          description: "Usuário não autenticado",
        });
        return;
      }

      // Preparar os dados do imóvel
      const propertyData = {
        title: data.propertyTitle,
        address: data.propertyAddress,
        type: data.propertyType,
        sale_price: data.propertyType === 'sale' ? data.salePrice : null,
        rent_price: data.propertyType === 'rent' ? data.rentPrice : null,
        seasonal_price: data.propertyType === 'seasonal' ? data.seasonalPrice : null,
        bedrooms: Number(data.bedrooms),
        bathrooms: Number(data.bathrooms),
        area: Number(data.area),
        land_area: Number(data.landArea),
        description: data.description,
        owner_id: selectedOwnerId || user.id,
        user_id: user.id,
        company_id: user.id, // Associa ao company_id do usuário logado
        specifications: {
          bedrooms: Number(data.bedrooms),
          bathrooms: Number(data.bathrooms),
          area: Number(data.area),
          parking: 0 // Valor padrão, pode ser adicionado ao formulário depois
        }
      };

      const { error } = await supabase
        .from('properties')
        .insert([propertyData]);

      if (error) throw error;

      toast({
        title: "Sucesso!",
        description: "Imóvel cadastrado com sucesso.",
      });

      navigate("/imoveis");
    } catch (error: any) {
      console.error('Erro ao cadastrar imóvel:', error);
      toast({
        variant: "destructive",
        title: "Erro ao cadastrar imóvel",
        description: error.message,
      });
    }
  };

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Novo Imóvel</h1>
      
      <div className="mb-6">
        <OwnerSelect
          owners={owners}
          value={selectedOwnerId}
          onChange={setSelectedOwnerId}
        />
      </div>

      <PropertyInfoForm
        propertyTitle={propertyTitle}
        propertyAddress={propertyAddress}
        propertyType={propertyType}
        salePrice={salePrice}
        rentPrice={rentPrice}
        seasonalPrice={seasonalPrice}
        bedrooms={bedrooms}
        bathrooms={bathrooms}
        area={area}
        landArea={landArea}
        description={description}
        setPropertyTitle={setPropertyTitle}
        setPropertyAddress={setPropertyAddress}
        setPropertyType={setPropertyType}
        setSalePrice={setSalePrice}
        setRentPrice={setRentPrice}
        setSeasonalPrice={setSeasonalPrice}
        setBedrooms={setBedrooms}
        setBathrooms={setBathrooms}
        setArea={setArea}
        setLandArea={setLandArea}
        setDescription={setDescription}
        onSubmit={handleSubmit}
      />
    </div>
  );
}